import angular from 'angular'
import role from './role'
import user from './user'
import department from './department'
import registrationCodeManagement from './registrationCodeManagement'

export default angular.module('system.permission', [role, user, department, registrationCodeManagement])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider.state('system.permission', {
            abstract: true,
            url: '/permission',
            template: '<div ui-view></div>',
            title: '权限管理',
        })
    }]).name


// WEBPACK FOOTER //
// ./src/app/system/permission/index.js